<template>
  <div class="job-aggregation-container">
    <w-nav-bar :nav_title="routeName.includes('interview') ? '邀约投递' : ''" @mobileLeftBtn="toRecommendJobs"/>
    <div class="job-aggregation-interview" v-if="routeName.includes('interview')" @click="changeInterviewSelected">
      <div class="job-interview-card" v-if="jobInterviewData[0]">
        <div class="flex-start">
          <i class="iconfont" :class="jobInterviewTokens.length ? 'iconxuanzhong' : 'iconweixuanzhong'"></i>
          <img class="hr-avatar" :src="jobInterviewData[0].hr_avatar" alt="">
          <span class="job-information">{{`${jobInterviewData[0].company_nick_name} · ${jobInterviewData[0].hr_company_position}`}}</span>
        </div>
        <div class="interview-message">{{applyMsg}}</div>
        <job-list :list-data="jobInterviewData" :options="{noResponse: true}"></job-list>
      </div>
    </div>
    <div class="job-aggregation-header flex-column-center" v-else>
      <span class="header-title">推荐职位</span>
      <span class="header-sub-title">{{pageSubTitle}}</span>
    </div>
    <div class="recommend-prompt flex-center" v-if="routeName.includes('interview')">以下是为你推荐的其他职位</div>
    <job-list :list-data="jobListData" :options="recommendListOptions" @changeSelectToken="changeSelectToken"></job-list>
    <div class="footer flex-start job-aggregation-bottom">
      <button class="job-aggregation-btn flex-center theme-button" :disabled="!selectJobTokens.length" @click="beforeJobMailing">
        一键投递 {{selectJobTokens.length}} 个职位
      </button>
    </div>
    <job-mailing :cv-data="mailingCvData" :state="jobMailingState" @handleClose="changeMailingState" @sendMailing="jobDelivery"></job-mailing>
    <job-alert :state="jobAlertShow" :page-data="jobDeliveryCvData" @handleClose="jobAlertShow = false"/>
    <w-loading :show-text="true" v-show="loadingState"></w-loading>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  const RouteMap = {
    'jobs-aggregation-publish': 'getRecommenderJobsByIntention',
    'jobs-aggregation-new': 'getRecommenderJobsByIntention',
    'jobs-aggregation-collect': 'getRecommenderJobsByJob',
    'jobs-aggregation-interview': 'getRecommenderJobs'
  }
  const routeArr = [
    'jobs-aggregation-publish',
    'jobs-aggregation-new',
    'jobs-aggregation-interview'
  ]
  const applyMsgAry = [
    'Hi，我们正在寻找优秀的小伙伴，要来尝试一下吗？',
    'Hi，对你的工作经历很感兴趣，方便发一份完整简历过来吗？',
    '你好，这个职位感觉很适合你，有没有兴趣加入我们的团队呢？'
  ]
  const pageSubTitleMap = {
    'jobs-aggregation-publish': '现在投递以下职位 HR 会优先筛选',
    'jobs-aggregation-new': '现在投递以下职位 HR 会优先筛选',
    'jobs-aggregation-collect': '根据你最近浏览的职位进行推荐',
  }
  import WNavBar from '../../components/global/w-navbar'
  import JobList from '../job-components/job-list'
  import JobMailing from '../job-components/job-mailing'
  import JobAlert from '../job-components/job-alert'
  import WLoading from '../../components/global/w-loading'
  import { componentsMixin } from '../../assets/js/mixin/components'
  import { loginMixin, envMixin } from '../../assets/js/mixin/global'
  export default {
    mixins: [componentsMixin, loginMixin, envMixin],
    data(){
      return {
        jobInterviewData: [],
        jobListData: [], // 列表数据
        recommendListOptions: { // 列表的一些配置项
          isSelect: true,
          isRecommendText: true
        },
        jobTokens: [], // 选择的token
        jobInterviewTokens: [],
        mailingCvData: [], // 可投递的简历数据
        jobMailingState: false, // 选择简历弹窗的状态
        jobAlertShow: false,
        jobDeliveryCvData: {},
        loadingState: false
      }
    },
    async mounted() {
      try {
        await this.loginByWx()
        this.verifyLogin()
        this.getJobList()
      } catch (error) {
        console.log(error)
      }
    },
    components: {
      JobList,
      WNavBar,
      JobMailing,
      JobAlert,
      WLoading
    },
    watch: {},
    computed: {
      routeName() {
        return this.$route.name
      },
      selectJobTokens() {
        return [...this.jobTokens, ...this.jobInterviewTokens]
      },
      applyMsg() {
        const index = Math.floor(Math.random() * 3)
        return applyMsgAry[index]
      },
      pageSubTitle() {
        return pageSubTitleMap[this.routeName]
      },
      ...mapState('cv', [ 'onlineCvData' ])
    },
    methods: {
      verifyLogin() {
        if (!this.alreadyLogged) {
          this.needLogin()
        }
      },
      // 更换选中的token
      changeSelectToken(tokens) {
        this.jobTokens = tokens
      },
      // 改变邀约职位的选中状态
      changeInterviewSelected() {
        if (this.jobInterviewTokens.length) {
          this.jobInterviewTokens = []
        } else if (this.jobInterviewData[0]) {
          this.jobInterviewTokens = [this.jobInterviewData[0].token]
        }
      },
      // 跳转到职位列表页
      toRecommendJobs() {
        this.$router.replace('/jobs/recommend')
      },
      // 职位投递之前选择简历一份简历的话直接投递
      beforeJobMailing() {
        if (this.alreadyLogged) {
          let { recruit_info: { apply_url }, cvs } = this.jobDeliveryCvData
          if (apply_url.url === '#job-deliver-alert') {
            this.jobAlertShow = true
          } else if (cvs && cvs.length === 1) {
            let { token } = cvs[0]
            this.jobDelivery(token)
          } else {
            this.mailingCvData = cvs
            this.changeMailingState()
          }
        } else {
          this.needLogin()
        }
      },
      // 更改选择简历弹窗的状态
      changeMailingState() {
        this.jobMailingState = !this.jobMailingState
      },
      // 获取职位信息
      async getJobList() {
        try {
          let payload = {
            page: 1,
            size: 10,
            strong_filter: true,
          }
          let res = null
          if (this.$route.name === 'jobs-aggregation-collect' && this.$route.query.jobToken) {
            payload.job_token = this.$route.query.jobToken
            res = await this.$api.recommend.jobToJob(payload)
          } else {
            if (this.onlineCvData.token) {
              payload.resume_token = this.onlineCvData.token
            } else if (this.onlineCvData.resume) {
              payload.resume_token = this.onlineCvData.resume.token
            }
            res = await this.$api.recommend.cvsToJob(payload)
          }
          // let res = await this.$api.jobs[RouteMap[this.$route.name]](payload)
          if (res.code === 1000) {
            this.getDeliveryData(res.data.jobs)
            if (this.routeName.includes('interview')) {
              this.jobInterviewData = [res.data.jobs[0]]
              let list = JSON.parse(JSON.stringify(res.data.jobs))
              list.shift()
              this.jobListData = list
              this.jobInterviewTokens = [res.data.jobs[0].token]
              this.jobTokens = list.map(item => item.token)
            } else {
              this.jobListData = res.data.jobs
              this.jobTokens = res.data.jobs.map(item => item.token)
            }
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 获取职位可投递的简历信息
      async getDeliveryData(jobs) {
        try {
          if (jobs instanceof Array) {
            let data = jobs.find(item => item.origin_source === 'jd')
            if (!data) {
              data = jobs[0]
            }
            if (data) {
              let res = await this.$api.jobs.getJobInfo(data.token)
              if (res.code === 1000) {
                this.jobDeliveryCvData = res.data
              }
            }
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 一键投递
      async jobDelivery(token) {
        try {
          this.loadingState = true
          let urlRes = await this.$api.cv.downloadCv(token, { watermark: 'yes' })
          let payload = {
            job_tokens: this.selectJobTokens,
            cv_token: token,
            cv_url: urlRes.data.url,
            cv_source: this.routeName.includes('interview') ? 'bulk_b' : 'bulk_a'
          }
          let res = await this.$api.HrApi.oneKeyDeliver(payload)
          this.loadingState = false
          if (res.code === 1000) {
            this.showToast(`成功投递${this.selectJobTokens.length}个职位`, 1500)
            setTimeout(() => {
              this.toRecommendJobs()
            }, 1500)
          }
        } catch (error) {
          this.loadingState = false
          console.log(error)
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .job-aggregation-container {
    background-color: #F9F9F9;
    min-height: $screen-height;
    @include mobile-container(44px, 74px);
    .mobile-nav {
      border-bottom: none;
    }
    .job-aggregation-header {
      padding: 10px 0 32px;
      background-color: $color-light;
      margin-bottom: 8px;
      .header-title {
        font-size: $font-size-large-x;
        color: $color-title;
        margin-bottom: 12px;
        font-weight: 500;
      }
      .header-sub-title {
        color: #9c9c9c;
      }
    }
    .recommend-prompt {
      background-color: $color-light;
      width: 100%;
      padding: 18px 0 24px;
      color: #9C9C9C;
      &::before, &::after {
        content: '';
        display: inline-block;
        width: 48px;
        height: 1px;
        background-color: #ECECEC;
      }
      &::before {
        margin-right: 12px;
      }
      &::after {
        margin-left: 12px;
      }
    }
    .job-aggregation-interview {
      padding: 24px 12px;
      background-color: $color-light;
      .job-interview-card {
        padding: 22px 18px 18px;
        box-shadow: 0 4px 16px 0 rgba($color: #032F81, $alpha: .08);
        border-radius: 8px;
        .iconweixuanzhong {
          color: #BCBCBC;
        }
        .iconxuanzhong {
          color: $color-theme;
        }
        .hr-avatar {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          margin-left: 12px;
          margin-right: 10px;
        }
        .job-information {
          font-size: $font-size-medium-x;
          color: $color-title;
        }
        .interview-message {
          @include bubble(auto, 68px, #F5F8FF, 1);
          background-color: #F5F8FF;
          padding: 14px 16px;
          color: $color-title;
          line-height: 22px;
          margin-bottom: 18px;
          margin-top: 14px;
          &::before {
            transform: rotate(180deg);
            top: inherit;
            bottom: 68px;
            left: 10%;
          }
        }
        .job-list {
          padding-top: 18px;
          border-top: 1px solid #F9F9F9;
          ::v-deep .job-content {
            padding: 0;
            .recommend-item {
              padding: 0;
            }
          }
        }
      }
    }
    .job-list {
      background-color: $color-light;
      ::v-deep .job-content {
        padding: 0 24px;
        border-bottom: 8px solid #F9F9F9;
        &:last-child {
          border: none;
        }
      }
    }
    .job-aggregation-bottom {
      width: 100vw;
      background-color: $color-light;
      padding: 0 24px;
      bottom: 0;
      @include ipx-footer(74px, 1px);
      .job-aggregation-btn {
        width: 100%;
        height: 42px;
        border-radius: 21px;
        font-size: $font-size-medium-x;
        &:disabled {
          background-color: #cfcfcf;
        }
      }
    }
  }
</style>